import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/notification.service';
import { PatientService } from 'src/app/shared/patient.service';

@Component({
  selector: 'app-newmembers',
  templateUrl: './newmembers.component.html',
  styleUrls: ['./newmembers.component.css']
})
export class NewmembersComponent implements OnInit {
  signupForm;
  submitted:false;
  Genders: string[] = ['Male', 'Female'];
  invalidNamesArr: string[] = ['Hello', 'Angular',' '];
  loaddata : Promise<Boolean>;
  constructor(@Inject(MAT_DIALOG_DATA) public data, public router : Router, public service : PatientService,
    private notificationService: NotificationService, private formBuilder: FormBuilder,public dialogRef:MatDialogRef<NewmembersComponent>) { }

  ngOnInit(): void {
    console.log(this.data);
    this.resetForm()
  }
  resetForm() {
    this.signupForm = this.formBuilder.group({
      membercode:[null],
      membername:['', Validators.required],
      email:  [''],
      phoneno:['', Validators.required],
      gender: ['', Validators.required],
      address:['', Validators.required],
      age: ['', Validators.required],
      userid : [this.id],

});
  }
  onSubmit() {
      this.service.signup = this.signupForm.value
      this.service.memberSignUp().subscribe(Response => {
        if (Response != 0) {
          this.notificationService.success(':: Registered successfully');
          console.log(this.id);
          if (this.id.substring(0,2)== "ML")
          {
            this.service.getNewUserid(this.id).subscribe((respon : any) => {
              this.loaddata = Promise.resolve(true);
              localStorage.setItem("userID", respon);  
              this.service.userid = respon;
              this.dialogRef.close();
              //console.log("respon");
              //console.log(respon);
              //this.userid = respon;  
              //this.gservice.getPendingOrders(this.userid);
              //console.log(respon);  
            })
          }
          else
          {
            this.dialogRef.close();
            //this.gservice.getPendingOrders(this.userid);
          }
          //this.router.navigate(['/members'])
        }
        else {
          this.notificationService.warn(':: This account is already existed');
          this.resetForm();
        }
      })
      // console.log(this.signupForm.get('user_name').value);
    // }
    
   }
  cancel(){
    //this.router.navigate(['/members'])
    this.submitted = false;
    this.resetForm();
  }

  get f(){
    return this.signupForm.controls;
  }

  get id() {
    return localStorage.getItem('userID')
  }

}



